// removed by extract-text-webpack-plugin
module.exports = {"Content":"_jeoPr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/Content.scss
// module id = 681
// module chunks = 0